import { Injectable } from '@angular/core';
import {
  ERROR_COMPONENT_CONSTANTS,
  OPENPAY_ERRORS,
} from '@app/domain/services/error/error.constants';
import { PaymentsFacade } from '@app/facades/payments.facade';
import { UtilService } from '@app/services/util.service';
import { environment } from '@environment';
import { AppFacade } from '../../facades/app.facade';
import { ErrorFacade } from '../../facades/error.facade';
import { UIService } from '../../services/ui.service';
import {
  EERROR_BUTTON_EVENT,
  EERROR_PAGE_TYPES,
  EERROR_TYPE,
  IErrorComponentData,
} from '../models/error.model';
import { AppAPI } from '@app/data/mo-api/app.api';
import { ERROR_CONSTANTS } from '@app/domain/services/error/error.constants';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  constructor(
    private _uiService: UIService,
    private _errorFacade: ErrorFacade,
    private _appFacade: AppFacade,
    private _utilService: UtilService,
    private _paymentsFacade: PaymentsFacade,
    private _appAPI: AppAPI
  ) {}

  public handleErrorButtonEvent(event: EERROR_BUTTON_EVENT) {
    switch (event) {
      case EERROR_BUTTON_EVENT.CONTINUE: {
        //TODO: Define when error codes has defined
        break;
      }
      case EERROR_BUTTON_EVENT.GO_TO_MY_PROFILE: {
        const route: string = environment.portal_url;
        this._utilService.onOpenLink(route);
        this._appFacade.killPurchase();
        break;
      }
      case EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE: {
        this._paymentsFacade.redirectToMerchant();
        break;
      }
      case EERROR_BUTTON_EVENT.SETUP_PASSWORD: {
        //TODO: Define when error codes has defined
        break;
      }
      case EERROR_BUTTON_EVENT.TRY_AGAIN: {
        this._paymentsFacade.setPaymentErrorCode();
        break;
      }
      case EERROR_BUTTON_EVENT.GO_TO_LANDING: {
        const route: string = environment.landing_url;
        this._utilService.onOpenLink(route);
        this._appFacade.killPurchase();
        break;
      }
    }
  }

  public handleError(
    message: string,
    errorType?,
    isCustomer?: boolean,
    callback?: Function,
    componentData?: IErrorComponentData
  ) {
    errorType = errorType ?? this._getErrorType();
    this._errorFacade.showError(message, errorType, callback, isCustomer, componentData);
  }

  public showError(
    message: string,
    errorType?,
    isCustomer?: boolean,
    callback?: Function,
    componentData?: IErrorComponentData
  ) {
    switch (errorType) {
      case EERROR_TYPE.SNACKBAR:
        this._uiService.showSnackbar(message, 'error');
        break;
      case EERROR_TYPE.MODAL:
        this._showGlobalMessage(message, callback);
        break;
      case EERROR_TYPE.COMPONENT:
        let errorComponentData: IErrorComponentData =
          ERROR_COMPONENT_CONSTANTS[EERROR_PAGE_TYPES.ERROR_01];

        if (!!componentData) {
          return this._errorFacade.showErrorComponent(componentData);
        }

        if (message) {
          if (
            message == ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_3002_CARD_EXPIRED ||
            message === '3002'
          ) {
            errorComponentData =
              isCustomer === true
                ? ERROR_COMPONENT_CONSTANTS[EERROR_PAGE_TYPES.ERROR_17]
                : ERROR_COMPONENT_CONSTANTS[EERROR_PAGE_TYPES.ERROR_09];
          }
          if (
            message == ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_3001_CARD_DECLINED_BY_BANK ||
            message === '3001'
          ) {
            errorComponentData =
              isCustomer === true
                ? ERROR_COMPONENT_CONSTANTS[EERROR_PAGE_TYPES.ERROR_21]
                : ERROR_COMPONENT_CONSTANTS[EERROR_PAGE_TYPES.ERROR_14];
          } else {
            Object.entries(OPENPAY_ERRORS).forEach(([key, value]) => {
              const hasError = value.includes(message);
              if (hasError) {
                errorComponentData = ERROR_COMPONENT_CONSTANTS[key];
                return;
              }
            });
          }
        }

        return this._errorFacade.showErrorComponent(errorComponentData);
      default:
        break;
    }
    this._appFacade.hideSplash();
  }

  public existSpecialCodes(message: string): boolean {
    let typeError: string;

    if (!message) return true;

    const specialErrors: Array<string> = [
      EERROR_PAGE_TYPES.ERROR_01,
      EERROR_PAGE_TYPES.ERROR_02,
      EERROR_PAGE_TYPES.ERROR_10,
      EERROR_PAGE_TYPES.ERROR_11,
      EERROR_PAGE_TYPES.ERROR_12,
    ];

    Object.entries(OPENPAY_ERRORS).forEach(([key, value]) => {
      const hasError = value.includes(message);
      if (hasError) {
        typeError = key;
        return;
      }
    });

    return specialErrors.includes(typeError);
  }

  private _showGlobalMessage(message: string, callback?: Function) {
    const data = {
      message,
      infoButton: {
        textOk: 'Aceptar',
        showButtonClose: false,
      },
      callbacks: {
        ok: () => callback(),
      },
    };
    // this._uiService.showDialog(data);
  }

  private _getErrorType() {
    return EERROR_TYPE.SNACKBAR;
  }
}
